<template>
    <el-dialog
            :title="`${productName} - 规格管理`"
            :visible="visible"
            width="900px"
            @close="handleClose"
            :close-on-click-modal="false"
    >
        <div class="spec-management">
            <!-- 规格属性管理 -->
            <el-card class="spec-attr-card" shadow="never">
                <div slot="header" class="clearfix">
                    <span>规格属性</span>
                    <el-button
                            type="primary"
                            size="mini"
                            style="float: right; padding: 3px 0"
                            @click="addSpecAttr"
                    >
                        添加属性
                    </el-button>
                </div>

                <el-table :data="specAttrs" border size="small">
                    <el-table-column prop="name" label="属性名称" width="120">
                        <template slot-scope="{ row, $index }">
                            <el-input
                                    v-if="row.editing"
                                    v-model="row.name"
                                    size="small"
                                    @blur="saveSpecAttr(row, $index)"
                                    @keyup.enter.native="saveSpecAttr(row, $index)"
                            />
                            <span v-else>{{ row.name }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="属性值">
                        <template slot-scope="{ row, $index }">
                            <div class="spec-values">
                                <el-tag
                                        v-for="(value, idx) in row.values"
                                        :key="idx"
                                        size="small"
                                        closable
                                        @close="removeSpecValue(row, idx, $index)"
                                >
                  <span
                          v-if="!value.editing"
                          @click="editSpecValue(row, idx)"
                  >
                    {{ value.name }}
                  </span>
                                    <el-input
                                            v-else
                                            v-model="value.name"
                                            size="mini"
                                            class="value-input"
                                            ref="valueInput"
                                            @blur="saveSpecValue(row, idx)"
                                            @keyup.enter.native="saveSpecValue(row, idx)"
                                    />
                                </el-tag>

                                <!-- 添加值的输入框 -->
                                <div class="add-value-input" v-if="row.showAddValue">
                                    <el-input
                                            v-model="row.newValue"
                                            size="mini"
                                            style="width: 100px"
                                            placeholder="输入值"
                                            @blur="addSpecValue(row)"
                                            @keyup.enter.native="addSpecValue(row)"
                                            ref="addValueInput"
                                            @click.native.stop
                                    />
                                    <el-button
                                            size="mini"
                                            type="text"
                                            @click="cancelAddValue(row)"
                                    >
                                        取消
                                    </el-button>
                                </div>

                                <el-button
                                        v-else
                                        type="text"
                                        size="mini"
                                        @click="startAddValue(row)"
                                >
                                    + 添加值
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="{ row, $index }">
                            <el-button
                                    type="text"
                                    size="mini"
                                    @click="toggleEditSpecAttr(row, $index)"
                            >
                                {{ row.editing ? '保存' : '编辑' }}
                            </el-button>
                            <el-button
                                    type="text"
                                    size="mini"
                                    style="color: #F56C6C"
                                    @click="removeSpecAttr($index)"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>

            <!-- SKU管理 -->
            <el-card class="sku-card" shadow="never">
                <div slot="header" class="clearfix">
                    <span>SKU列表</span>
                    <el-button
                            type="primary"
                            size="mini"
                            style="float: right; padding: 3px 0"
                            @click="generateSkus"
                            :disabled="!canGenerateSkus"
                    >
                        生成SKU
                    </el-button>
                </div>

                <el-table :data="skus" border size="small">
                    <el-table-column
                            v-for="attr in specAttrs"
                            :key="attr.id"
                            :label="attr.name"
                            width="120"
                    >
                        <template slot-scope="{ row }">
                            {{ row.specs[attr.name] }}
                        </template>
                    </el-table-column>

                    <el-table-column label="价格" width="120">
                        <template slot-scope="{ row }">
                            <el-input-number
                                    v-model="row.price"
                                    :min="0"
                                    :precision="2"
                                    :step="0.01"
                                    size="small"
                                    controls-position="right"
                            />
                        </template>
                    </el-table-column>

                    <el-table-column label="库存" width="100">
                        <template slot-scope="{ row }">
                            <el-input-number
                                    v-model="row.stock"
                                    :min="0"
                                    size="small"
                                    controls-position="right"
                            />
                        </template>
                    </el-table-column>

                    <el-table-column label="图片" width="120">
                        <template slot-scope="{ row }">
                            <el-upload
                                    class="sku-image-upload"
                                    action="/api/upload"
                                    :show-file-list="false"
                                    :on-success="(res) => handleSkuImageSuccess(res, row)"
                                    :before-upload="beforeImageUpload"
                            >
                                <img v-if="row.image" :src="row.image" class="sku-image" />
                                <div v-else class="sku-image-placeholder">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </el-upload>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="80" align="center">
                        <template slot-scope="{ $index }">
                            <el-button
                                    type="text"
                                    size="mini"
                                    style="color: #F56C6C"
                                    @click="removeSku($index)"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleSave" :loading="submitting">
                保存规格
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'eSpecManagementDialog',
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            productId: {
                type: [Number, String],
                required: false,
                default: null,
                validator: function(value) {
                    // 允许 null，或者数字/字符串
                    return value === null || typeof value === 'number' || typeof value === 'string'
                }
            },
            productName: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false,
                submitting: false,
                specAttrs: [],
                skus: []
            }
        },
        computed: {
            canGenerateSkus() {
                return this.specAttrs.length > 0 &&
                    this.specAttrs.every(attr => attr.values.length > 0)
            }
        },
        watch: {
            visible(val) {
                if (val) {
                    this.loadSpecs()
                }
            }
        },
        methods: {
            async loadSpecs() {
                this.loading = true
                try {
                    const param = {
                        access_token: sessionStorage.getItem('token'),
                        company_id: sessionStorage.getItem('company_id'),
                        productId: this.productId
                    }
                    const res = await this.$axios.findProductSpecs(param)
                    this.specAttrs = res.data.attrs || []
                    this.skus = res.data.skus || []

                    // 初始化添加值的状态
                    this.specAttrs.forEach(attr => {
                        this.$set(attr, 'showAddValue', false)
                        this.$set(attr, 'newValue', '')
                    })
                } catch (error) {
                    console.error('加载规格失败:', error)
                    this.specAttrs = []
                    this.skus = []
                } finally {
                    this.loading = false
                }
            },

            addSpecAttr() {
                const newAttr = {
                    id: Date.now(),
                    name: '',
                    values: [],
                    editing: true,
                    showAddValue: false,
                    newValue: ''
                }
                this.specAttrs.push(newAttr)

                // 聚焦到名称输入框
                this.$nextTick(() => {
                    const inputs = this.$el.querySelectorAll('.el-table .el-input__inner')
                    if (inputs.length > 0) {
                        const lastInput = inputs[inputs.length - 1]
                        lastInput.focus()
                    }
                })
            },

            toggleEditSpecAttr(row, index) {
                console.log(index)
                row.editing = !row.editing
                if (!row.editing && row.name) {
                    this.generateSkus()
                }
            },

            saveSpecAttr(row, index) {
                console.log(index)
                if (row.name && row.name.trim()) {
                    row.editing = false
                    this.generateSkus()
                }
            },

            removeSpecAttr(index) {
                this.specAttrs.splice(index, 1)
                if (this.specAttrs.length === 0) {
                    this.skus = []
                }
            },

            // 开始添加值
            startAddValue(row) {
                row.showAddValue = true
                row.newValue = ''

                // 聚焦到输入框
                this.$nextTick(() => {
                    const input = this.$refs.addValueInput
                    if (input && input.focus) {
                        input.focus()
                    }
                })
            },

            // 添加属性值
            addSpecValue(row) {
                if (row.newValue && row.newValue.trim()) {
                    // 检查是否已存在相同的值
                    const exists = row.values.some(value =>
                        value.name === row.newValue.trim()
                    )

                    if (!exists) {
                        row.values.push({
                            name: row.newValue.trim(),
                            editing: false
                        })
                        row.showAddValue = false
                        row.newValue = ''
                        this.generateSkus()
                    } else {
                        this.$message.warning('该属性值已存在')
                    }
                } else {
                    row.showAddValue = false
                    row.newValue = ''
                }
            },

            // 取消添加值
            cancelAddValue(row) {
                row.showAddValue = false
                row.newValue = ''
            },

            editSpecValue(row, valueIndex) {
                const value = row.values[valueIndex]
                this.$set(value, 'editing', true)

                // 聚焦到输入框
                this.$nextTick(() => {
                    const inputs = this.$el.querySelectorAll('.value-input')
                    if (inputs.length > 0) {
                        const input = inputs[valueIndex]
                        if (input && input.focus) {
                            input.focus()
                        }
                    }
                })
            },

            saveSpecValue(row, valueIndex) {
                const value = row.values[valueIndex]
                if (value.name && value.name.trim()) {
                    value.editing = false
                    this.generateSkus()
                } else {
                    // 如果输入为空，删除该值
                    row.values.splice(valueIndex, 1)
                    this.generateSkus()
                }
            },

            removeSpecValue(row, valueIndex, index) {
                console.log(index)
                row.values.splice(valueIndex, 1)
                this.generateSkus()
            },

            generateSkus() {
                if (!this.canGenerateSkus) {
                    this.skus = []
                    return
                }

                // 递归生成所有规格组合
                const generateCombinations = (arrays, index = 0, current = {}, result = []) => {
                    if (index === arrays.length) {
                        result.push({
                            id: Date.now() + Math.random(),
                            specs: { ...current },
                            price: 0,
                            stock: 0,
                            image: '',
                            skuCode: this.generateSkuCode()
                        })
                        return result
                    }

                    const attr = arrays[index]
                    for (const value of attr.values) {
                        current[attr.name] = value.name
                        generateCombinations(arrays, index + 1, current, result)
                    }

                    return result
                }

                const specArrays = this.specAttrs.map(attr => ({
                    name: attr.name,
                    values: attr.values
                }))

                this.skus = generateCombinations(specArrays)
            },

            generateSkuCode() {
                return `SKU${Date.now()}${Math.floor(Math.random() * 1000)}`
            },

            handleSkuImageSuccess(res, row) {
                row.image = res.data.url
            },

            removeSku(index) {
                this.skus.splice(index, 1)
            },

            beforeImageUpload(file) {
                const isImage = file.type.startsWith('image/')
                const isLt2M = file.size / 1024 / 1024 < 2

                if (!isImage) {
                    this.$message.error('只能上传图片文件!')
                }
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 2MB!')
                }

                return isImage && isLt2M
            },

            async handleSave() {
                try {
                    this.submitting = true

                    const data = {
                        access_token:sessionStorage.getItem('token'),
                        company_id:sessionStorage.getItem('company_id'),
                        productId: this.productId,
                        attrs: this.specAttrs.map(attr => ({
                            name: attr.name,
                            values: attr.values.map(v => v.name)
                        })),
                        skus: this.skus
                    }

                    await this.$axios.saveProductSpecs(data)
                    this.$message.success('保存成功')
                    this.$emit('success')
                    this.handleClose()
                } catch (error) {
                    console.error('保存规格失败:', error)
                    this.$message.error('保存失败')
                } finally {
                    this.submitting = false
                }
            },

            handleClose() {
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>
    .spec-management {
        max-height: 60vh;
        overflow-y: auto;
    }

    .spec-attr-card {
        margin-bottom: 20px;
    }

    .spec-values {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        min-height: 32px;
    }

    .add-value-input {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .sku-image-upload {
        width: 60px;
        height: 60px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .sku-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .sku-image-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8c939d;
    }

    .el-tag {
        cursor: pointer;
        position: relative;
    }

    .el-tag:hover {
        opacity: 0.8;
    }

    .value-input {
        width: 60px;
    }
</style>
